import React from 'react';
import PropTypes from 'prop-types';

import {
    Anchor, Button, ButtonGroup, Flex, Heading, IconEdit, Paragraph, Text,
} from '@zillow/constellation';
import {
    Container,
} from '@zillow/zrs-comet';

import WizardBodyTemplate from 'app/shared/components/WizardBodyTemplate';
import Accordion from '../components/Accordion';

import { StyledHR } from './StyledComponents';

const accordionArray = [
    {
        header: 'Qualified renters',
        content:
    <>
        <Paragraph fontType="bodySmall" marginBottom="lg">
            Simplify screening tenants by using Zillow’s online application for your Rent Guarantee property.
            You can select the right tenant for you from a pool of qualified applicants.
        </Paragraph>
        <Paragraph fontType="bodySmall">
            Choose any tenant who meets the Rent Guarantee eligibility criteria:
        </Paragraph>
        <Paragraph fontType="bodySmall">
            • Credit score of 500 or higher (your minimum score still applies)
        </Paragraph>
        <Paragraph fontType="bodySmall">
            • Monthly income at least 2x the rent amount
        </Paragraph>
        <Paragraph fontType="bodySmall">
            • Cleared with background check, including criminal &amp; eviction history
        </Paragraph>
    </>,
    },
    {
        header: 'Easy claim filing',
        content:
    <>
        <Paragraph fontType="bodySmall" marginBottom="lg">
            Streamline the claims process by uploading your lease to Zillow, or creating a new one using our tool.
            With your lease terms and tenant info on hand, we can receive and process your claim quickly.
        </Paragraph>
        <Paragraph fontType="bodySmall">
        Submit your claim online 24/7 to get financial protection covering:
        </Paragraph>
        <Paragraph fontType="bodySmall">
         - Missed rent payments up to 3 months during the lease
        </Paragraph>
        <Paragraph fontType="bodySmall">
         - Property damage up to $5,000
        </Paragraph>
    </>,
    },
    {
        header: 'Fast payment',
        content:
    <>
        <Paragraph fontType="bodySmall" marginBottom="lg">
            With Zillow online payments, your tenant can pay rent directly into your bank account, and we’ll have a
             record of any missed payments to help us process your claim fast.
        </Paragraph>
        <Flex display="flex" flexDirection="row" alignItems="center">
            <IconEdit size="lg" marginRight="sm" />
            <Text>Claim payments are deposited into your bank acount</Text>
        </Flex>
        <Flex display="flex" flexDirection="row" alignItems="center">
            <IconEdit size="lg" marginRight="sm" />
            <Text>No lost rental income</Text>
        </Flex>
        <Flex display="flex" flexDirection="row" alignItems="center">
            <IconEdit size="lg" marginRight="sm" />
            <Text>Quickly receive money to make repairs</Text>
        </Flex>
    </>,
    },
];

const propTypes = {
    onGoToNextStep: PropTypes.func.isRequired,
};
const defaultProps = {};

const HowItWorks = ({ onGoToNextStep }) => {
    const renderSubtitle = () => (
        <>
            {'With Rent Guarantee, Zillow has you covered if something goes wrong. '}
            <Text fontType="bodyHeading"><Anchor>See what&apos;s covered</Anchor></Text>
            <Flex display="flex" flexDirection="column" alignItems="center">
                <StyledHR color="yellow300" />
            </Flex>
            <Heading level="4" marginBottom="md">Better than a security deposit</Heading>
            <Paragraph>
                We’ll cover up to 3 months of missed rents during the lease, or up to $5,000 for damage to your
                rental property. Our online tools make the claims and payment process fast and easy.
            </Paragraph>
        </>
    );

    return (
        <WizardBodyTemplate
            title="Protect your investment"
            subtitle={renderSubtitle()}
        >
            <Flex display="flex" justifyContent="center" alignItems="center" marginTop="lg">
                <Container>
                    {accordionArray.map((accordion) => {
                        const { header, content } = accordion;
                        return (
                            <Accordion header={header} content={content} marginBottom="xs" />
                        );
                    })}
                </Container>
            </Flex>
            <Flex display="flex" justifyContent="center" marginTop="md">
                <ButtonGroup>
                    <Button buttonType="primary" onClick={onGoToNextStep}>Get Rent Guarantee</Button>
                    <Button buttonType="secondary">Not interested</Button>
                </ButtonGroup>
            </Flex>
        </WizardBodyTemplate>

    );
};

HowItWorks.propTypes = propTypes;
HowItWorks.defaultProps = defaultProps;

export default HowItWorks;
